import cn from "classnames";
import Link from "next/link";
import { match } from "ts-pattern";

import { useFunnelContext } from "shared/Funnel/FunnelContextProvider";
import { useCatalogPageContext } from "shared/catalog/CatalogPageContext/useCatalogPageContext";


export const CatalogCategories = () => {
  const { tags, selectedTagState: [selectedTag] } = useCatalogPageContext();
  const { isSwap } = useFunnelContext();

  const getPath = (tagSlug: string) => {
    const isSelected = selectedTag === tagSlug

    return match({ isSelected, isSwap })
      .with({ isSelected: true, isSwap: false }, () => "/smartphone")
      .with({ isSelected: false, isSwap: false }, () => `/smartphone/${tagSlug}`)
      .with({ isSelected: true, isSwap: true }, () => "/swap/smartphone")
      .with({ isSelected: false, isSwap: true }, () => `/swap/smartphone/${tagSlug}`)
      .run();
  }
  
  return (
    <div className="flex overflow-x-auto flex-1 py-5 px-7 -my-5 -mx-7 w-screen lg:w-auto">
      <div className="flex gap-1.5 items-center lg:flex-wrap">
        {tags.filter(tag => tag.isCatalogFilter).map(tag => (
          <Link key={tag.slug} href={getPath(tag.slug)} scroll={false} shallow>
            <a>
              <div className={cn(
                "py-1.5 px-4 w-max text-sm rounded-md border cursor-pointer",
                tag.slug === selectedTag ? "bg-cornflower-blue border-cornflower-blue text-white font-medium" : "bg-white border-black/20"
              )}>
                {tag.name}
              </div>
            </a>
          </Link>
        ))}
      </div>
    </div>
  );
};
